<template>
  <div class="newDetails">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-container">
      <div class="container">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/company' }">新闻动态</el-breadcrumb-item>
          <el-breadcrumb-item v-if="infoData.length">{{infoData[0].NewsTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    
    <div class="container" v-if="infoData.length">
      <!-- 文章头部 -->
      <div class="article-header">
        <h1 class="article-title">{{infoData[0].NewsTitle}}</h1>
        <div class="article-meta">
          <span class="meta-item">
            <i class="el-icon-date"></i>
            {{formatDate(infoData[0].CreateTime)}}
          </span>
          <span class="meta-item" v-if="infoData[0].NewsCategory">
            <i class="el-icon-collection-tag"></i>
            {{infoData[0].NewsCategory}}
          </span>
          <span class="meta-item">
            <i class="el-icon-view"></i>
            {{infoData[0].ViewCount || 0}} 阅读
          </span>
        </div>
      </div>
      
      <!-- 文章摘要 -->
      <div class="article-brief" v-if="infoData[0].NewsBrief">
        <p>{{infoData[0].NewsBrief}}</p>
      </div>
      
      <!-- 文章内容 -->
      <div class="article-content">
        <div v-html="infoData[0].NewsDesc"></div>
      </div>
      
      <!-- 文章底部 -->
      <div class="article-footer">
        <div class="article-tags" v-if="infoData[0].NewsTags">
          <span class="tag-label">标签：</span>
          <el-tag 
            v-for="(tag, index) in infoData[0].NewsTags.split(',')" 
            :key="index" 
            size="small" 
            effect="plain">
            {{tag}}
          </el-tag>
        </div>
        
        <div class="article-share">
          <span class="share-label">分享到：</span>
          <div class="share-icons">
            <i class="el-icon-share"></i>
            <i class="el-icon-chat-dot-round"></i>
          </div>
        </div>
      </div>
      
      <!-- 相关推荐 -->
      <div class="related-articles" v-if="relatedNews.length > 0">
        <h3 class="related-title">相关推荐</h3>
        <div class="related-list">
          <div class="related-item" v-for="(item, index) in relatedNews" :key="index">
            <router-link :to="{path:'/newDetails',query:{Id:item.Id}}">
              <div class="related-image">
                <img :src="item.NewsImg" :alt="item.NewsTitle">
              </div>
              <div class="related-info">
                <h4>{{item.NewsTitle}}</h4>
                <p class="related-date">{{formatDate(item.CreateTime)}}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 加载状态 -->
    <div class="loading-container" v-else>
      <el-skeleton :rows="15" animated />
    </div>
  </div>
</template>

<script>
export default {
 name: "newDetails",
  data(){
    return{
      infoData:[],
      relatedNews: []
    }
  },
  mounted() {
    this.getInfo(this.$route.query.Id);
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
  },
  methods:{
    //获取信息
    getInfo(id){
      let data = {params:{Id:id}};
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntNewsIdSelect',data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.infoData = res.data;
        console.log(res);
        
        // 获取相关新闻
        if(this.infoData.length > 0) {
          this.getRelatedNews(this.infoData[0].NewsCate);
        }
      })
    },
    
    // 获取相关新闻
    getRelatedNews(cateId) {
      let data = {params:{NewsCate: cateId || 0}};
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntNewsSelect',data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        // 过滤掉当前新闻
        const currentId = Number(this.$route.query.Id);
        this.relatedNews = res.data
          .filter(item => item.Id !== currentId)
          .slice(0, 3); // 只取3条相关新闻
      })
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }
  }
}
</script>

<style scoped>
.newDetails {
  background-color: #f9f9fa;
  padding-bottom: 60px;
}

/* 面包屑导航 */
.breadcrumb-container {
  background-color: #fff;
  padding: 15px 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  margin-bottom: 30px;
}

/* 容器样式 */
.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 文章头部 */
.article-header {
  background: #fff;
  padding: 30px;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.article-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.4;
}

.article-meta {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  color: #999;
  font-size: 14px;
}

.meta-item {
  display: flex;
  align-items: center;
}

.meta-item i {
  margin-right: 5px;
}

/* 文章摘要 */
.article-brief {
  background: #f8f9fa;
  padding: 20px 30px;
  border-left: 4px solid #1890ff;
  margin-bottom: 20px;
  color: #666;
  font-size: 15px;
  line-height: 1.6;
}

.article-brief p {
  margin: 0;
}

/* 文章内容 */
.article-content {
  background: #fff;
  padding: 30px;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  margin-bottom: 30px;
}

.article-content :deep(img) {
  max-width: 100%;
  height: auto;
  margin: 15px 0;
  border-radius: 4px;
}

.article-content :deep(p) {
  line-height: 1.8;
  margin: 15px 0;
  color: #333;
}

.article-content :deep(h1),
.article-content :deep(h2),
.article-content :deep(h3),
.article-content :deep(h4) {
  margin: 25px 0 15px;
  color: #333;
}

.article-content :deep(a) {
  color: #1890ff;
  text-decoration: none;
}

.article-content :deep(blockquote) {
  border-left: 4px solid #1890ff;
  padding: 10px 20px;
  background: #f8f9fa;
  margin: 20px 0;
  color: #666;
}

.article-content :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.article-content :deep(th),
.article-content :deep(td) {
  border: 1px solid #e8e8e8;
  padding: 10px;
  text-align: left;
}

.article-content :deep(th) {
  background: #f8f9fa;
}

/* 文章底部 */
.article-footer {
  background: #fff;
  padding: 20px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.article-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.tag-label, .share-label {
  color: #666;
  font-size: 14px;
}

.article-share {
  display: flex;
  align-items: center;
  gap: 10px;
}

.share-icons {
  display: flex;
  gap: 15px;
}

.share-icons i {
  font-size: 18px;
  color: #666;
  cursor: pointer;
  transition: color 0.3s ease;
}

.share-icons i:hover {
  color: #1890ff;
}

/* 相关推荐 */
.related-articles {
  background: #fff;
  padding: 25px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.related-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.related-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.related-item {
  transition: all 0.3s ease;
}

.related-item:hover {
  transform: translateY(-5px);
}

.related-item a {
  display: flex;
  gap: 15px;
  text-decoration: none;
  color: inherit;
}

.related-image {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.related-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.related-item:hover .related-image img {
  transform: scale(1.1);
}

.related-info {
  flex: 1;
  min-width: 0;
}

.related-info h4 {
  font-size: 15px;
  color: #333;
  margin: 0 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.3s ease;
}

.related-item:hover .related-info h4 {
  color: #1890ff;
}

.related-date {
  font-size: 13px;
  color: #999;
  margin: 0;
}

/* 加载状态 */
.loading-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 30px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .article-title {
    font-size: 22px;
  }
  
  .article-header, 
  .article-content, 
  .article-footer,
  .related-articles {
    padding: 20px;
  }
  
  .related-list {
    grid-template-columns: 1fr;
  }
}
</style>

<style>
/* 全局样式，保留原有的样式 */
.esmartMargin {
  left: 0 !important;
  right: 0 !important;
  margin: 50px auto !important;
  overflow: hidden !important;
  position:static !important;
}
</style>
<template>
  <div class="newDetails">
    <!-- 面包屑导航 -->
    <div class="breadcrumb-container">
      <div class="container">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="{ path: '/company' }">新闻动态</el-breadcrumb-item>
          <el-breadcrumb-item v-if="infoData.length">{{infoData[0].NewsTitle}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>
    </div>
    
    <div class="container" v-if="infoData.length">
      <!-- 文章头部 -->
      <div class="article-header">
        <h1 class="article-title">{{infoData[0].NewsTitle}}</h1>
        <div class="article-meta">
          <span class="meta-item">
            <i class="el-icon-date"></i>
            {{formatDate(infoData[0].CreateTime)}}
          </span>
          <span class="meta-item" v-if="infoData[0].NewsCategory">
            <i class="el-icon-collection-tag"></i>
            {{infoData[0].NewsCategory}}
          </span>
          <span class="meta-item">
            <i class="el-icon-view"></i>
            {{infoData[0].ViewCount || 0}} 阅读
          </span>
        </div>
      </div>
      
      <!-- 文章摘要 -->
      <div class="article-brief" v-if="infoData[0].NewsBrief">
        <p>{{infoData[0].NewsBrief}}</p>
      </div>
      
      <!-- 文章内容 -->
      <div class="article-content">
        <div v-html="infoData[0].NewsDesc"></div>
      </div>
      
      <!-- 文章底部 -->
      <div class="article-footer">
        <div class="article-tags" v-if="infoData[0].NewsTags">
          <span class="tag-label">标签：</span>
          <el-tag 
            v-for="(tag, index) in infoData[0].NewsTags.split(',')" 
            :key="index" 
            size="small" 
            effect="plain">
            {{tag}}
          </el-tag>
        </div>
        
        <div class="article-share">
          <span class="share-label">分享到：</span>
          <div class="share-icons">
            <i class="el-icon-share"></i>
            <i class="el-icon-chat-dot-round"></i>
          </div>
        </div>
      </div>
      
      <!-- 相关推荐 -->
      <div class="related-articles" v-if="relatedNews.length > 0">
        <h3 class="related-title">相关推荐</h3>
        <div class="related-list">
          <div class="related-item" v-for="(item, index) in relatedNews" :key="index">
            <router-link :to="{path:'/newDetails',query:{Id:item.Id}}">
              <div class="related-image">
                <img :src="item.NewsImg" :alt="item.NewsTitle">
              </div>
              <div class="related-info">
                <h4>{{item.NewsTitle}}</h4>
                <p class="related-date">{{formatDate(item.CreateTime)}}</p>
              </div>
            </router-link>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 加载状态 -->
    <div class="loading-container" v-else>
      <el-skeleton :rows="15" animated />
    </div>
  </div>
</template>

<script>
export default {
 name: "newDetails",
  data(){
    return{
      infoData:[],
      relatedNews: []
    }
  },
  mounted() {
    this.getInfo(this.$route.query.Id);
    // 页面加载时滚动到顶部
    window.scrollTo(0, 0);
  },
  methods:{
    //获取信息
    getInfo(id){
      let data = {params:{Id:id}};
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntNewsIdSelect',data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        this.infoData = res.data;
        console.log(res);
        
        // 获取相关新闻
        if(this.infoData.length > 0) {
          this.getRelatedNews(this.infoData[0].NewsCate);
        }
      })
    },
    
    // 获取相关新闻
    getRelatedNews(cateId) {
      let data = {params:{NewsCate: cateId || 0}};
      this.$axios.get('http://82.156.125.76:5000/api/Byt_Ent_Gateway/BytEntNewsSelect',data).then(res=>{
        res = typeof res.data=='string'? JSON.parse(res.data):res.data;
        // 过滤掉当前新闻
        const currentId = Number(this.$route.query.Id);
        this.relatedNews = res.data
          .filter(item => item.Id !== currentId)
          .slice(0, 3); // 只取3条相关新闻
      })
    },
    
    // 格式化日期
    formatDate(dateString) {
      if (!dateString) return '';
      const date = new Date(dateString);
      return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
    }
  }
}
</script>

<style scoped>
.newDetails {
  background-color: #f9f9fa;
  padding-bottom: 60px;
}

/* 面包屑导航 */
.breadcrumb-container {
  background-color: #fff;
  padding: 15px 0;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  margin-bottom: 30px;
}

/* 容器样式 */
.container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 0 20px;
}

/* 文章头部 */
.article-header {
  background: #fff;
  padding: 30px;
  border-radius: 8px 8px 0 0;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  text-align: center;
  border-bottom: 1px solid #f0f0f0;
}

.article-title {
  font-size: 28px;
  color: #333;
  margin-bottom: 20px;
  line-height: 1.4;
}

.article-meta {
  display: flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: 20px;
  color: #999;
  font-size: 14px;
}

.meta-item {
  display: flex;
  align-items: center;
}

.meta-item i {
  margin-right: 5px;
}

/* 文章摘要 */
.article-brief {
  background: #f8f9fa;
  padding: 20px 30px;
  border-left: 4px solid #1890ff;
  margin-bottom: 20px;
  color: #666;
  font-size: 15px;
  line-height: 1.6;
}

.article-brief p {
  margin: 0;
}

/* 文章内容 */
.article-content {
  background: #fff;
  padding: 30px;
  border-radius: 0 0 8px 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  margin-bottom: 30px;
}

.article-content :deep(img) {
  max-width: 100%;
  height: auto;
  margin: 15px 0;
  border-radius: 4px;
}

.article-content :deep(p) {
  line-height: 1.8;
  margin: 15px 0;
  color: #333;
}

.article-content :deep(h1),
.article-content :deep(h2),
.article-content :deep(h3),
.article-content :deep(h4) {
  margin: 25px 0 15px;
  color: #333;
}

.article-content :deep(a) {
  color: #1890ff;
  text-decoration: none;
}

.article-content :deep(blockquote) {
  border-left: 4px solid #1890ff;
  padding: 10px 20px;
  background: #f8f9fa;
  margin: 20px 0;
  color: #666;
}

.article-content :deep(table) {
  width: 100%;
  border-collapse: collapse;
  margin: 20px 0;
}

.article-content :deep(th),
.article-content :deep(td) {
  border: 1px solid #e8e8e8;
  padding: 10px;
  text-align: left;
}

.article-content :deep(th) {
  background: #f8f9fa;
}

/* 文章底部 */
.article-footer {
  background: #fff;
  padding: 20px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
  margin-bottom: 30px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  gap: 15px;
}

.article-tags {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 10px;
}

.tag-label, .share-label {
  color: #666;
  font-size: 14px;
}

.article-share {
  display: flex;
  align-items: center;
  gap: 10px;
}

.share-icons {
  display: flex;
  gap: 15px;
}

.share-icons i {
  font-size: 18px;
  color: #666;
  cursor: pointer;
  transition: color 0.3s ease;
}

.share-icons i:hover {
  color: #1890ff;
}

/* 相关推荐 */
.related-articles {
  background: #fff;
  padding: 25px 30px;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

.related-title {
  font-size: 18px;
  color: #333;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 1px solid #f0f0f0;
}

.related-list {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
  gap: 20px;
}

.related-item {
  transition: all 0.3s ease;
}

.related-item:hover {
  transform: translateY(-5px);
}

.related-item a {
  display: flex;
  gap: 15px;
  text-decoration: none;
  color: inherit;
}

.related-image {
  width: 80px;
  height: 80px;
  border-radius: 4px;
  overflow: hidden;
  flex-shrink: 0;
}

.related-image img {
  width: 100%;
  height: 100%;
  object-fit: cover;
  transition: transform 0.5s ease;
}

.related-item:hover .related-image img {
  transform: scale(1.1);
}

.related-info {
  flex: 1;
  min-width: 0;
}

.related-info h4 {
  font-size: 15px;
  color: #333;
  margin: 0 0 8px;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  transition: color 0.3s ease;
}

.related-item:hover .related-info h4 {
  color: #1890ff;
}

.related-date {
  font-size: 13px;
  color: #999;
  margin: 0;
}

/* 加载状态 */
.loading-container {
  max-width: 1000px;
  margin: 0 auto;
  padding: 30px 20px;
  background: white;
  border-radius: 8px;
  box-shadow: 0 2px 12px rgba(0,0,0,0.05);
}

/* 响应式调整 */
@media (max-width: 768px) {
  .article-title {
    font-size: 22px;
  }
  
  .article-header, 
  .article-content, 
  .article-footer,
  .related-articles {
    padding: 20px;
  }
  
  .related-list {
    grid-template-columns: 1fr;
  }
}
</style>

<style>
/* 全局样式，保留原有的样式 */
.esmartMargin {
  left: 0 !important;
  right: 0 !important;
  margin: 50px auto !important;
  overflow: hidden !important;
  position:static !important;
}
</style>